var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.viewLogsShow,
          expression: "viewLogsShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "viewLogs" } }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "title-text" }, [
            _vm.summary && _vm.summary.tranferWay == "restore"
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("language.popup.viewLogsPopup.titleRe")))
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("language.popup.viewLogsPopup.title")))
                ]),
            _vm._v(
              "\n                " + _vm._s(_vm.taskName) + "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "view-logs-body"
          },
          [
            !_vm.loading && !_vm.summary
              ? _c("div", { staticClass: "view-logs-none" }, [
                  _vm._v(_vm._s(_vm.$t("language.common.taskNotRun")))
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.loading && _vm.summary
              ? _c("div", { staticClass: "view-logs-summary" }, [
                  _c("div", { staticClass: "view-logs-status" }, [
                    _vm.result == 1
                      ? _c("div", { staticClass: "view-logs-status-item" }, [
                          _c("div", {
                            staticClass: "task-success task-status-icon-big"
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("language.common.success")))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.result == 2
                      ? _c("div", { staticClass: "view-logs-status-item" }, [
                          _c("div", {
                            staticClass: "task-patial task-status-icon-big"
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("language.common.patial")))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.result == -1
                      ? _c("div", { staticClass: "view-logs-status-item" }, [
                          _c("div", {
                            staticClass: "task-failure task-status-icon-big"
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("language.common.failure")))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.result == 0
                      ? _c("div", { staticClass: "view-logs-status-item" }, [
                          _c("div", {
                            staticClass: "task-cancel task-status-icon-big"
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("language.common.canceled")))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.result != 0 &&
                    _vm.result != -1 &&
                    _vm.result != 1 &&
                    _vm.result != 2
                      ? _c("div", { staticClass: "view-logs-status-item" }, [
                          _c("div", { staticClass: "task-status-icon-big" }),
                          _vm._v(" "),
                          _c("div")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.typeId == 102
                      ? _c("div", { staticClass: "view-logs-census" }, [
                          _vm.summary.errorNum
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "view-logs-count have-click-text",
                                  staticStyle: { color: "#F54958" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openFailedFiles()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "view-logs-count-num" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.summary.errorNum) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.viewLogsPopup.errorNum"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.summary.addNum) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.popup.viewLogsPopup.addNum")
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.summary.updateNum) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.updateNum"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.summary.deleteNum) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.deleteNum"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("formatByte")(_vm.summary.totalBytes)
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.syncSize"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("conversionMilliseconds")(
                                      _vm.summary.runningTime
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.syncTime"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typeId == 103
                      ? _c("div", { staticClass: "view-logs-census" }, [
                          _vm.summary.errorNum
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "view-logs-count have-click-text",
                                  staticStyle: { color: "#F54958" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openFailedFiles()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "view-logs-count-num" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.summary.errorNum) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.viewLogsPopup.errorNum"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.summary.totalNum) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.backupNum"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("formatByte")(_vm.summary.totalBytes)
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.backupSize"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("conversionMilliseconds")(
                                      _vm.summary.runningTime
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.backupTime"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typeId != 103 && _vm.typeId != 102
                      ? _c("div", { staticClass: "view-logs-census" }, [
                          _vm.summary.errorNum
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "view-logs-count have-click-text",
                                  staticStyle: { color: "#F54958" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openFailedFiles()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "view-logs-count-num" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.summary.errorNum) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.viewLogsPopup.errorNum"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.summary.totalNum) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.popup.viewLogsPopup.tranNum")
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("formatByte")(_vm.summary.totalBytes)
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.tranSize"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "view-logs-count" }, [
                            _c("div", { staticClass: "view-logs-count-num" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("conversionMilliseconds")(
                                      _vm.summary.runningTime
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.viewLogsPopup.tranTime"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.loading && _vm.summary
              ? _c("div", { staticClass: "view-logs-source" }, [
                  _c("div", { staticClass: "view-logs-source-items" }, [
                    _c(
                      "div",
                      {
                        staticClass: "view-logs-source-singel",
                        style: _vm.typeId == 104 ? "padding-left: 15px;" : ""
                      },
                      [
                        _vm.typeId != 104
                          ? _c("div", { staticClass: "source-name" }, [
                              _vm.lang == "jp"
                                ? _c("span", [
                                    _vm.typeId == 102
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.sync"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.typeId == 103
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.backup"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.typeId != 103 && _vm.typeId != 102
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.tran"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.viewDetail.type == 1 ||
                              (_vm.viewDetail.type == 6 &&
                                _vm.summary.tranferWay != "restore")
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.viewLogsPopup.to"
                                          )
                                        ) +
                                        "       \n                            "
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.viewLogsPopup.from"
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                              _vm._v(" "),
                              _vm.lang == "jp"
                                ? _c("span", [_vm._v("：")])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "path-name-txt",
                                  attrs: {
                                    title: _vm._f("getCatalog")(
                                      _vm.singleSource.nodes
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.jumpToCloud(_vm.singleSource)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getCatalog")(
                                        _vm.singleSource.nodes
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _c("div", { staticClass: "source-name" }, [
                              _c("div", {
                                staticClass:
                                  "task-icon clouds_logo clouds_logo_20",
                                class: _vm.summary.fromItem.cloudType
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "source-email-name",
                                  attrs: {
                                    title: _vm.summary.fromItem.fileName
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.jumpToCloud(
                                        _vm.summary.fromItem
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.summary.fromItem.fileName))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "double_arrow" }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "task-icon clouds_logo clouds_logo_20",
                                class: _vm.summary.toItem.cloudType
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "source-email-name",
                                  attrs: { title: _vm.summary.toItem.fileName },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.jumpToCloud(_vm.summary.toItem)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.summary.toItem.fileName))]
                              )
                            ]),
                        _vm._v(" "),
                        _vm.summary.startTime
                          ? _c(
                              "div",
                              [
                                _vm.typeId == 102 &&
                                _vm.syncSourceList.length > 1
                                  ? _c(
                                      "el-dropdown",
                                      { on: { command: _vm.handleSyncSource } },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.executeTime"
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm._f("transferForMatTime")(
                                                    _vm.summary.startTime
                                                  )
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  _vm._f("transferForMatTime")(
                                                    _vm.summary.endTime
                                                  )
                                                )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            staticStyle: { padding: "0" },
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown"
                                          },
                                          _vm._l(_vm.syncSourceList, function(
                                            log,
                                            index
                                          ) {
                                            return _c(
                                              "el-dropdown-item",
                                              {
                                                key: index,
                                                staticClass: "logs-popup-drop",
                                                attrs: { command: index }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f(
                                                      "transferForMatTime"
                                                    )(log.summary.startTime)
                                                  ) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "transferForMatTime"
                                                      )(log.summary.endTime)
                                                    )
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.viewLogsPopup.executeTime"
                                          )
                                        ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("transferForMatTime")(
                                              _vm.summary.startTime
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm._f("transferForMatTime")(
                                              _vm.summary.endTime
                                            )
                                          )
                                      )
                                    ])
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "view-logs-source-items" }, [
                    _c(
                      "div",
                      {
                        staticClass: "view-logs-source-table",
                        class: _vm.typeId != 104 ? "un-business-tran" : ""
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.multiSource,
                              stripe: "",
                              "tooltip-effect": "dark",
                              height: "390"
                            }
                          },
                          [
                            _vm.typeId == 104
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "language.popup.viewLogsPopup.sourceAccount"
                                    ),
                                    "min-width": "260"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "table-cell",
                                                attrs: {
                                                  title: scope.row.fromEmail
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.fromEmail)
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    50530920
                                  )
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.typeId == 104
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "language.popup.viewLogsPopup.targetAccounts"
                                    ),
                                    "min-width": "260"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "table-cell",
                                                attrs: {
                                                  title: scope.row.toEmail
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.toEmail)
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1001600712
                                  )
                                })
                              : _c("el-table-column", {
                                  attrs: {
                                    label: _vm.showFromOrToTableName,
                                    "min-width": _vm.typeId != 102 ? 520 : 420
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("div", {
                                              staticClass: "small-file",
                                              class: scope.row.source.isDir
                                                ? "folder-small"
                                                : _vm.matchfileType(
                                                    scope.row.source.name
                                                  )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "table-cell path-name-txt",
                                                attrs: {
                                                  title: _vm._f("getCatalog")(
                                                    scope.row.source.nodes
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.jumpToCloudMult(
                                                      scope.row.source
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("getCatalog")(
                                                      scope.row.source.nodes
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    782431877
                                  )
                                }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("language.common.fileProcess"),
                                "min-width": _vm.typeId != 102 ? 175 : 230
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "table-cell" },
                                          [
                                            _vm.typeId != 102
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(scope.row.readyNum) +
                                                      " / " +
                                                      _vm._s(scope.row.totalNum)
                                                  )
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.popup.viewLogsPopup.add"
                                                      ) +
                                                        scope.row.addNum +
                                                        " " +
                                                        _vm.$t(
                                                          "language.popup.viewLogsPopup.update"
                                                        ) +
                                                        scope.row.updateNum +
                                                        " " +
                                                        _vm.$t(
                                                          "language.popup.viewLogsPopup.delete"
                                                        ) +
                                                        scope.row.deleteNum
                                                    )
                                                  )
                                                ])
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1205301080
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("language.common.dataProcess"),
                                "min-width": "175"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "table-cell" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatByte")(
                                                  scope.row.totalBytes
                                                )
                                              ) +
                                                " / " +
                                                _vm._s(
                                                  _vm._f("formatByte")(
                                                    scope.row.readedBytes
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                345831761
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t(
                                  "language.popup.viewLogsPopup.tranTime"
                                ),
                                "min-width": "155"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "table-cell" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f(
                                                  "conversionMilliseconds"
                                                )(scope.row.runningTime)
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2754490047
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t(
                                  "language.popup.viewLogsPopup.executeResult"
                                ),
                                "min-width": "175"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "table-cell" },
                                          [
                                            scope.row.result == -1
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.failure"
                                                      )
                                                    )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            scope.row.result == 0
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.cancel"
                                                      )
                                                    )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            scope.row.result == 1
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.success"
                                                      )
                                                    )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            scope.row.result == 2
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.patial"
                                                      )
                                                    )
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                482760612
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-056ea970", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-056ea970","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/view_logs_popup.vue
// module id = null
// module chunks = 